document.addEventListener("DOMContentLoaded", function () {
  lottie.play();
});

document.addEventListener("DOMContentLoaded", function () {
  var inMotion = lottie.loadAnimation({
    container: document.getElementById("in-motion"), // the dom element that will contain the animation
    renderer: "svg",
    loop: true,
    autoplay: true,
    path: "/wp-content/themes/tasowheel/modules/lottie/assets/animations/in-motion.json", // the path to the animation json,
    rendererSettings: {
      // context: canvasContext, // the canvas context
      preserveAspectRatio: "xMidYMid slice", // Supports the same options as the svg element's preserveAspectRatio property
      // clearCanvas: false,
      progressiveLoad: false, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
      // hideOnTransparent: true, //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
      // className: 'some-css-class-name',
      // viewBoxSize: '0 0 100 100',
    },
  });

  var ping = lottie.loadAnimation({
    container: document.getElementById("ping"), // the dom element that will contain the animation
    renderer: "svg",
    loop: true,
    autoplay: true,
    path: "/wp-content/themes/tasowheel/modules/lottie/assets/animations/ping.json", // the path to the animation json,
    rendererSettings: {
      // context: canvasContext, // the canvas context
      preserveAspectRatio: "xMidYMid slice", // Supports the same options as the svg element's preserveAspectRatio property
      // clearCanvas: false,
      progressiveLoad: false, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
      // hideOnTransparent: true, //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
      // className: 'some-css-class-name',
      // viewBoxSize: '0 0 100 100',
    },
  });

  var menuPing = lottie.loadAnimation({
    container: document.querySelector("#masthead #menuPing"), // the dom element that will contain the animation
    renderer: "svg",
    loop: true,
    autoplay: true,
    path: "/wp-content/themes/tasowheel/modules/lottie/assets/animations/ping.json", // the path to the animation json,
    rendererSettings: {
      // context: canvasContext, // the canvas context
      preserveAspectRatio: "xMidYMid slice", // Supports the same options as the svg element's preserveAspectRatio property
      // clearCanvas: false,
      progressiveLoad: false, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
      // hideOnTransparent: true, //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
      // className: 'some-css-class-name',
      // viewBoxSize: '0 0 100 100',
    },
  });
});
